export var datepickerCalendarCellStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    return Object.assign({
      height: v.calendarCellHeight,
      width: v.calendarCellWidth,
      padding: v.calendarCellPadding,
      ':hover': {
        backgroundColor: v.calendarCellHoverBackgroundColor,
        color: v.calendarCellHoverColor
      }
    }, p.quiet && {
      color: v.calendarCellQuietColor
    }, p.selected && {
      color: v.calendarCellSelectedColor,
      backgroundColor: v.calendarCellSelectedBackgroundColor
    }, p.disabled && {
      color: v.calendarCellDisabledColor,
      cursor: 'default',
      backgroundColor: v.calendarCellDisabledBackgroundColor,
      ':hover': {}
    });
  }
};
//# sourceMappingURL=datepickerCalendarCellStyles.js.map
